const API_BASE_URL =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'https://api.neogtm.com'
    : 'https://api.neogtm.com';

/** Load current user's alma mater rows for a tenant (per-user personalization). */
export async function fetchUserUniversities(tenantId, userId) {
  if (!tenantId || !userId) return [];
  try {
    const res = await fetch(
      `${API_BASE_URL}/api/settings/personalization?tenant_id=${encodeURIComponent(tenantId)}&user_id=${encodeURIComponent(userId)}`,
      {
        credentials: 'include',
        headers: {
          'X-Tenant-ID': String(tenantId),
          'X-User-ID': String(userId),
        },
      }
    );
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data.user_universities) ? data.user_universities : [];
  } catch {
    return [];
  }
}
